import React from 'react';
import './styles.scss';

interface LoaderProps {
  /** Whether to display in fullscreen mode */
  fullscreen?: boolean;
  /** Source component name for debugging */
  source: string;
}

export const Loader: React.FC<LoaderProps> = ({ fullscreen = false, source }) => {
  if (fullscreen) {
    return (
      <div className="w-[100vw] h-[100vh] flex justify-center items-center bg-[#2b2b2c]">
        <div data-source={source} className="lds-facebook">
          <div></div>
          <div></div>
          <div></div>
        </div>
        {
          process.env.NODE_ENV === 'development' && (
            <span className="text-white" data-source={source}>{source}</span>
          )
        }
      </div>
    );
  }

  return (
    <div data-source={source} className="lds-facebook">
      <div></div>
      <div></div>
      <div></div>
      {
        process.env.NODE_ENV === 'development' && (
          <span className="text-white" data-source={source}>{source}</span>
        )
      }
    </div>
  );
};
